import * as React from "react";
function findPathParent(obj, arr) {
  if (!obj)
    return;
  arr.push(obj.type);
  const children = obj.props?.children;
  if (obj.type === "path" && !children) {
    return arr.pop();
  } else if (typeof children === "object") {
    if (Array.isArray(children)) {
      for (let i = 0; i < children.length; i++) {
        const result = findPathParent(children[i], arr);
        if (result) {
          break;
        }
      }
    } else {
      findPathParent(children, arr);
    }
  } else {
    arr.pop();
  }
}
function addNewStyle(newStyle) {
  let styleElement = document.getElementById("styles_js");
  if (!styleElement) {
    styleElement = document.createElement("style");
    styleElement.type = "text/css";
    styleElement.id = "styles_js";
    document.getElementsByTagName("head")[0].appendChild(styleElement);
  }
  styleElement.appendChild(document.createTextNode(newStyle));
}
function changePathStyle(props, arr, id) {
  if (!props)
    return;
  const str = arr.join(" ");
  const root = arr[0];
  const others = arr.slice(1);
  if (props.color) {
    addNewStyle(root + "#" + id + " " + others.join(" ") + " path:nth-of-type(1) {fill: " + props.color + "}");
  }
  if (props["data-hovercolor"]) {
    addNewStyle(root + "#" + id + ":hover " + others.join(" ") + " path:nth-of-type(1) {fill: " + props["data-hovercolor"] + "}");
  }
  if (props["data-activecolor"]) {
    addNewStyle(root + "#" + id + ":active " + others.join(" ") + " path:nth-of-type(1) {fill: " + props["data-activecolor"] + "}");
  }
  if (Array.isArray(props["data-twotonecolor"])) {
    addNewStyle(root + "#" + id + " " + others.join(" ") + " path:nth-of-type(1) {fill: " + props["data-twotonecolor"][0] + "}");
    addNewStyle(root + "#" + id + " " + others.join(" ") + " path:nth-of-type(2) {fill: " + props["data-twotonecolor"][1] + "}");
  }
  if (Array.isArray(props["data-hovertwotonecolor"])) {
    addNewStyle(root + "#" + id + ":hover " + others.join(" ") + " path:nth-of-type(1) {fill: " + props["data-hovertwotonecolor"][0] + "}");
    addNewStyle(root + "#" + id + ":hover " + others.join(" ") + " path:nth-of-type(2) {fill: " + props["data-hovertwotonecolor"][1] + "}");
  }
  if (Array.isArray(props["data-activetwotonecolor"])) {
    addNewStyle(root + "#" + id + ":active " + others.join(" ") + " path:nth-of-type(1) {fill: " + props["data-activetwotonecolor"][0] + "}");
    addNewStyle(root + "#" + id + ":active " + others.join(" ") + " path:nth-of-type(2) {fill: " + props["data-activetwotonecolor"][1] + "}");
  }
  if (props.width) {
    addNewStyle(root + "#" + id + "{width: " + props.width + "}");
  }
  if (props.height) {
    addNewStyle(root + "#" + id + "{height: " + props.height + "}");
  }
}
const isArrayContainsElement = (arr1, arr2) => {
  for (let i = 0; i < arr2.length; i++) {
    if (arr1.includes(arr2[i])) {
      return true;
    }
  }
  return false;
};
const OPTIONS = ["color", "data-activecolor", "data-hovercolor", "data-twotonecolor", "data-hovertwotonecolor", "data-activetwotonecolor", "width", "height"];
const SvgQuery = (props) => {
  const isSetOptions = isArrayContainsElement(Object.keys(props), OPTIONS);
  const svg = /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", id: "query_svg_plugin_8037", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.62651 13.9861C11.8973 13.9861 14.5486 11.3348 14.5486 8.06401C14.5486 4.79324 11.8973 2.14192 8.62651 2.14192C5.35574 2.14192 2.70442 4.79324 2.70442 8.06401C2.70442 11.3348 5.35574 13.9861 8.62651 13.9861ZM14.1204 13.1712L16.552 15.6035C16.8567 15.9156 16.8507 16.4155 16.5387 16.7201C16.2267 17.0248 15.7267 17.0188 15.4221 16.7068L12.9277 14.21C11.6679 15.0941 10.1656 15.5673 8.62651 15.5649C4.48282 15.5649 1.125 12.2071 1.125 8.06401C1.125 3.92092 4.48342 0.5625 8.62651 0.5625C12.769 0.5625 16.1274 3.92092 16.1274 8.06401C16.1274 10.0367 15.3658 11.8316 14.1204 13.1712Z" }));
  if (isSetOptions) {
    const parents = [];
    findPathParent(svg, parents);
    const id = svg.props.id;
    changePathStyle(props, parents, id);
  }
  return svg;
};
export default SvgQuery;
